import { useEffect, useRef, useState, useCallback } from "react";

//next
// import Link from 'next/link';
import Image from "next/image";

import styles from "styles/components/header.module.scss";

//material
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
// import Button from '@mui/material/Button';
import IconButton from "@mui/material/IconButton";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

//3rd party
// import { isMobileOnly} from "react-device-detect";
import { isMobileOnly } from "react-device-detect";
// import ReactPlayer from 'react-player';
import ReactPlayer from "react-player/youtube";
import { motion } from "framer-motion";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

//assets
// import bannerPoster from 'assets/Pictures/shine/poster.webp';
import IconArrowDown from "assets/Pictures/icon-arrow-down.svg";

const variants = {
  open: { opacity: 1, y: 0, pointerEvents: "all" },
  closed: { opacity: 0, y: 20, pointerEvents: "none" },
};

function TexturePopupComponent({
 
  youtube,
  posterdesktop,
  postermobile,
  isimage,
  listText,
  listBtnText,
}) {
  const isMobile = isMobileOnly;

  const [videoH, setvideoH] = useState("");
  useEffect(() => {
    setvideoH((360 / 640) * window.innerWidth);
    // console.log("new h = "+videoH)
  }, []);

  const [isImage, setIsImage] = useState(false);
  const [titleclass, settitleclass] = useState("video_title");

  const [isOpenVideo, setIsOpenVideo] = useState(false);

  const playerOnPlay = () => {
    console.log("playerOnPlay");
    setIsOpenVideo(true);
  };
  const playerOnPuase = () => {
    console.log("playerOnPuase");
    setTimeout(() => {
      setplayerPlaying(false);
      setIsOpenVideo(false);
    }, 1000);
  };
  const playerOnEnded = () => {
    console.log("playerOnEnded");
    setplayerPlaying(false);
    setIsOpenVideo(false);
  };
  const playerOnReady = () => {
    // console.log("playerOnReady");
  };

  const [playerPlaying, setplayerPlaying] = useState(false);
  const btn_play = () => {
    setplayerPlaying(true);
    setIsOpenVideo(true);
    // setIsOpenVideo(isOpenVideo => !isOpenVideo)
  };

  const scrollDown = () => {
    document.getElementById("the-lifeshine-collection").scrollIntoView({
      behavior: "smooth",
    });
  };

  const [posterSrc, setposterSrc] = useState();
  useEffect(() => {
    setposterSrc(isMobile ? postermobile : posterdesktop);
    setIsImage(isimage == "1" ? true : false);
    settitleclass(isimage == "1" ? "image_title" : "video_title");
  }, []);

  return (
    <List className={`${styles.list_download} list_download list_watch`}>
      <ListItem className={`${styles.list_item} list_item`}>
        <ListItemText className={`${styles.list_label} list_label`} primary={listText} />
        <a className={`${styles.list_link} list_link`} onClick={btn_play} > 
            <ListItemText className={`${styles.list_download} list_download`} primary={listBtnText} />
        </a>
        </ListItem>

        <motion.div
        className={`${styles.motion_div} motion_div`}
        animate={isOpenVideo ? "open" : "closed"}
        variants={variants}
      >
        <ReactPlayer
          onPlay={playerOnPlay}
          // onPause={playerOnPuase}
          onEnded={playerOnEnded}
          onReady={playerOnReady}
          playing={playerPlaying}
          playsinline={true}
          controls={true}
          className={`${styles.react_player} react_player`}
          url={youtube}
          width="100%"
          height="200px"
          config={{
            youtube: {
              playerVars: { showinfo: 0 },
            },
          }}
        />
      </motion.div> 
      </List>

      
  );
}
export default TexturePopupComponent;
